<template>
  <div> 
    <b-modal ref="license-checker-modal">  


         <div slot="modal-title">
      Summary - Fix all Issues<br>
      
      </div>
      <b-container class="modal-content-container" v-if="data.length!=0">
        <span style="font-weight:700">  Asset Component ID : </span>{{data[0].ORDER_ID}} <br>
      <span style="font-weight:700"> Serial No :</span> {{data[0].ENTITLEMENT_ID}} <br>
      <hr>
        <b-row v-for="item in getIssues" :key="item.ORDER_ID" >
         
            
            <b-col cols="8" :class="item.status===true?'color-green':'color-red'">{{item.name}}</b-col>
             <b-col cols="1"><license-checker-check-cross
                          :check="item.status===true"
                          :cross="item.status===false"
                        /></b-col>
                        <b-col cols="3"></b-col>
          
        </b-row>
      </b-container>
      <div slot="modal-footer" />

       
    </b-modal>
  </div>
 
</template>
<script>
import LicenseCheckerCheckCross from './license-checker-check-cross'

export default {
  name: 'LicenseCheckerModal',
  components: { LicenseCheckerCheckCross },
  data () {
    return {
      issues: ''
    }
  },
  props: {
    data: { type: Array, default: () => ([]) }
  },
  mounted () {
  },
  computed: {
    getIssues () {
      return this.issues
    }
  },
  methods: {
    showModal () {
      this.issues = []
      let allStatuses = this.data.map(x => x.ACTION_STATUS)
      if (allStatuses.filter(x => x.IsNotAutoAllocated === 'Success').length >= 1) {
        this.issues.push({name: 'Auto Allocation Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsNotAutoAllocated === 'Failure').length >= 1) {
        this.issues.push({name: 'Auto Allocation Fix', status: false})
      }
      if (allStatuses.filter(x => x.IsCADSDataIncorrect === 'Success').length >= 1) {
        this.issues.push({name: 'CADS Data Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsCADSDataIncorrect === 'Failure').length >= 1) {
        this.issues.push({name: 'CADS Data Fix', status: false})
      }
      if (allStatuses.filter(x => x.IsDataNotInSyncWithSAP === 'Success').length >= 1) {
        this.issues.push({name: 'SAP Data Sync', status: true})
      }
      if (allStatuses.filter(x => x.IsDataNotInSyncWithSAP === 'Failure').length >= 1) {
        this.issues.push({name: 'SAP Data Sync', status: false})
      }
      if (allStatuses.filter(x => x.IsOrderIdMissingInFNO === 'Success').length >= 1) {
        this.issues.push({name: 'Create Line Item Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsOrderIdMissingInFNO === 'Failure').length >= 1) {
        this.issues.push({name: 'Create Line Item Fix', status: false})
      }
      if (allStatuses.filter(x => x.IsRenewalIncorrect === 'Success').length >= 1) {
        this.issues.push({name: 'Renewal Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsRenewalIncorrect === 'Failure').length >= 1) {
        this.issues.push({name: 'Renewal Fix', status: false})
      }
      if (allStatuses.filter(x => x.IsOrderIdNotUpdated === 'Success').length >= 1 && allStatuses.filter(x => x.IsOrderIdNotUpdated === 'Failure').length === 0) {
        this.issues.push({name: 'OrderID Update Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsOrderIdNotUpdated === 'Success').length >= 0 && allStatuses.filter(x => x.IsOrderIdNotUpdated === 'Failure').length >= 1) {
        this.issues.push({name: 'OrderID Update Fix', status: false})
      }
      if (allStatuses.filter(x => x.IsLineItemStateIncorrect === 'Success').length >= 1 && allStatuses.filter(x => x.IsLineItemStateIncorrect === 'Failure').length === 0) {
        this.issues.push({name: 'Line Item Status Fix', status: true})
      }
      if (allStatuses.filter(x => x.IsLineItemStateIncorrect === 'Success').length >= 0 && allStatuses.filter(x => x.IsLineItemStateIncorrect === 'Failure').length >= 1) {
        this.issues.push({name: 'Line Item Status Fix', status: false})
      }
      this.$nextTick(() => {
        this.openModal()
      })
    },
    openModal () {
      this.$refs['license-checker-modal'].show()
    },
    hideModal () {
      this.$refs['license-checker-modal'].hide()
    }
  }
}
</script>
<style scoped>
.color-green{
color:#179716;
}

.color-red{
color:red
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-modal.vue